type Props = Readonly<{}>;

export default function NotFoundPage(_props: Props) {
  return (
    <div>
      <h1>404</h1>
      <p>The page you are looking for is not available or does not exist.</p>
    </div>
  );
}
